module.exports = __webpack_public_path__ + "img/logoEDM.bc2972ad.png";